import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { BackButton } from '@/components/BackButton'

import ComponentDnd from './components/ComponentPanel/ComponentDnd'
import ComponentSetting from './components/ComponentPanel/ComponentSetting'

/**
 * builder leading-sidebar component panel
 */
export function ComponentPanel() {
  const { activeComponent, setActiveComponent } = useAppBuilderContext()
  return (
    <>
      <div className={clsx('component-panel component-setting mk-builder-panel', !activeComponent && 'hidden')}>
        <div className='flex items-center'>
          <BackButton
            bottomBorder
            onClick={() => {
              setActiveComponent(undefined)
            }}
          />
          {activeComponent && (
            <div className='w-full border-b h-12 flex-c justify-end ltr:pr-4 rtl:pl-4 bdr text-m-sm text-primary-500'>
              <Trans>Editing</Trans> {activeComponent.compId} <Trans>component</Trans>
            </div>
          )}
        </div>
        {activeComponent && <ComponentSetting />}
      </div>

      <ComponentDnd />
    </>
  )
}
